var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('div',{staticClass:"container"},[_c('StudioMediaDetails',{attrs:{"media":_vm.media}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }